// extracted by mini-css-extract-plugin
export var progressBar = "_ib-0";
export var progressBarInner = "_ib-1";